<template>
  <div
    class="relative group grow mb-4"
    tabindex="-1"
  >
    <div class="block bg-sky-400 py-2 px-2 xl:px-8 rounded font-bold text-center text-lg md:text-xl text-white cursor-pointer uppercase">
      <span class="block xl:hidden">
        <span class="fa fa-calendar mr-1" />
        Zet in agenda
      </span>
      <span class="hidden xl:block">
        Zet deze veiling als reminder in mijn agenda
      </span>
    </div>

    <div class="hidden group-hover:flex group-focus-within:flex absolute flex-col w-full bg-white rounded-b border divide-y">
      <a
        :href="route('frontend.theme-auctions.calendar', {themeAuction: themeAuction.slug, type: 'ical'})"
        target="_blank"
        class="hover:bg-sky-100 text-lg py-3 px-6"
      >
        <i class="fab fa-apple mr-2" />
        Apple
      </a>
      <a
        :href="route('frontend.theme-auctions.calendar', {themeAuction: themeAuction.slug, type: 'google'})"
        target="_blank"
        class="hover:bg-sky-100 text-lg py-3 px-6"
      >
        <i class="fab fa-google mr-2" />
        Google
      </a>
      <a
        :href="route('frontend.theme-auctions.calendar', {themeAuction: themeAuction.slug, type: 'ical'})"
        target="_blank"
        class="hover:bg-sky-100 text-lg py-3 px-6"
      >
        <i class="far fa-calendar mr-2" />
        iCal bestand
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    themeAuction: {
      required: true,
      type: Object,
    },
  },
};
</script>
